import { icons } from "../../utils/icons";

export const Icon = ({ name = "", ...spanAttributes }) => {
	if (!name) throw new Error("icon name not provided");
	if (!icons[name]) throw new Error("icon not found");

	return (
		<div
			{...spanAttributes}
			className={`icon-container icon-${name} ${spanAttributes?.className}`}
			dangerouslySetInnerHTML={{ __html: icons[name] }}
		></div>
	);
};
